// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"816":"cb4130e0","818":"13a7eea5"}[chunkId] + ".chunk.css";
};